import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import TaskTableRow from './TaskTableRow';
import { PsTable } from '../../../../shared/components/table/PsTable';

export default class TasksTable extends React.Component {

    renderHead() {
        return (
            <tr>
                <th/>
                <th>{I18nUtils.tr('TR_FECHA')}</th>
                <th>{I18nUtils.tr('TR_OBRA')}</th>
                <th>{I18nUtils.tr('TR_SUBCONTRATA')}</th>
                <th className="text-center">{I18nUtils.tr('TR_MENSUAL')}</th>
                <th className="text-center">{I18nUtils.tr('TR_VINCULADOS')}</th>
                <th className="text-center">{I18nUtils.tr('TR_TRABAJADORES')}</th>
                <th className="text-center">{I18nUtils.tr('TR_SUBCONTRATA')}</th>
                <th className="text-right">{I18nUtils.tr('TR_ENVIAR_ESTADO')}</th>
            </tr>
        );
    }

    render() {
        const {
            data,
            error,
            active,
            showSelectFiltersMessage,
        } = this.props;
        const showNoTasks = !showSelectFiltersMessage && ( !data || data.length === 0 );

        if ( error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{error}</h3>
                </section>
            );
        }
        if ( showNoTasks ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{I18nUtils.tr('TR_NO_EXISTEN_TAREAS')}</h3>
                </section>
            );
        }
        if ( showSelectFiltersMessage ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{I18nUtils.tr('TR_SELECCIONE_LOS_PARAMETROS_DE_BUSQUEDA')}</h3>
                </section>
            );
        }
        return (
            <PsTable headings={this.renderHead()}>
                {
                    data.map((task, index) => {
                        return (
                            <TaskTableRow
                                key={index}
                                task={task}
                                active={active}
                                rowsClassName={index % 2 === 0 ? 'subtask-bg' : ''}
                            />
                        );
                    })
                }
            </PsTable>
        );
    }

}

TasksTable.propTypes = {
    data: PropTypes.any,
    error: PropTypes.string,
    active: PropTypes.number,
    showSelectFiltersMessage: PropTypes.bool,
};

TasksTable.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/components/TasksTable.jsx